import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { CustomersRest } from './../customers.rest';
import { LoginRest } from '../../../login/login.rest';
import { CustomerDetailsHeaderComponent } from './header/customer-details-header.component';
import { MatTabChangeEvent } from '@angular/material';
import { CustomerSystemVersionsComponent } from '../customer-details/system-versions/customer-system-versions/customer-system-versions.component';
import { MenuButton } from '../../../core/shared/tabmenu/tabmenu.model';
import { Customer, License } from '../customers.model';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { GridParamsRestoringService } from '../../../core/services/grid-params-restoring/grid-params-restoring.service';
import { CustomerEmployeesComponent } from './customer-employees/customer-employees.component';
import { CustomerLicensesComponent } from './customer-licenses/customer-licenses.component';


@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss']
})
export class CustomerDetailsComponent implements OnInit, HasPermissions, AfterViewInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private rest: CustomersRest,
    private permissionsService: PermissionsService,
    private spinnerService: SpinnerService,
    private gridParamsRestoringService: GridParamsRestoringService) { }

  private canShowSystemVersions: boolean;
  private canShowCustomerEmployees: boolean;
  private customer: Customer;
  private isNew: boolean;
  private customerId: number;
  private isSaving = false;
  private nipOld : string;

  private menuButtons: MenuButton[] = [
    { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.saveCustomer(); }, enabled: false, isForSelected: false },
    { text: 'COMMONBUTTONS_close', class: "btn-danger", icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false },
    { text: 'Zablokuj kontrahenta', class: "btn-danger", icon: '', onClick: () => { this.block(); }, enabled: false, isForSelected: false },
    { text: 'Odblokuj kontrahenta', class: "btn-warning", icon: '', onClick: () => { this.unblock(); }, enabled: false, isForSelected: false }
  ];
  private saveButton = { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.saveCustomer(); }, enabled: false, isForSelected: false };

  @ViewChild(CustomerDetailsHeaderComponent) customerDetailsHeaderComponent: CustomerDetailsHeaderComponent;
  @ViewChild(CustomerEmployeesComponent) customerEmployeesComponent: CustomerEmployeesComponent;
  @ViewChild(CustomerSystemVersionsComponent) customerSystemVersionsComponent: CustomerSystemVersionsComponent;
  @ViewChild(CustomerLicensesComponent) customerLicensesComponent: CustomerLicensesComponent;

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if ((this.customerEmployeesComponent != null
      && ((this.customerEmployeesComponent.employeeModal && this.customerEmployeesComponent.employeeModal.modal.modalRoot.isShown === true)
        || (this.customerEmployeesComponent.employeeSelectionModal && this.customerEmployeesComponent.employeeSelectionModal.modal.modalRoot.isShown === true)))
      || (this.customerSystemVersionsComponent != null
        && this.customerSystemVersionsComponent.systemVersionsSelectionModal.modal.modalRoot.isShown === true)
      || (this.customerDetailsHeaderComponent != null
        && this.customerDetailsHeaderComponent.isDialogActive)
      || (this.customerLicensesComponent != null
        && this.customerLicensesComponent.licenseModal.modal.modalRoot.isShown === true)) {
      return;
    }
    if(this.permissions.canEdit) {
      this.saveCustomer();
    }
    event.preventDefault();
  }

  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionsService.getUserPermissions(claimType);
  }

  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions('Customer');
    let customerId = null;
    this.canShowSystemVersions = this.permissionsService.getUserPermissions('CustomerSystemVersion').canShow;
    this.canShowCustomerEmployees = this.permissionsService.getUserPermissions('CustomerEmployee').canShow;
    if (this.permissions.canAdd || this.permissions.canEdit) {
      this.menuButtons.find(x => x.text === 'COMMONBUTTONS_save').enabled = true;
      this.saveButton.enabled = true;
    }

    this.route.queryParams.subscribe(params => {
      if (params.id != null) {
        customerId = parseInt(params.id);
      }

      if (customerId != null) {
        this.spinnerService.show();
        this.rest.getCustomerDetails(customerId).subscribe(customer => {
          this.isNew = false;
          this.customer = customer;
          this.customerId = customerId;
          this.nipOld = customer.nip;
          this.customerDetailsHeaderComponent.setModel(this.customer, this.isNew, this.permissions.canEdit);
          this.setMenuButtonsPermissions();
          this.spinnerService.hide();
        });
      } else {
        this.isNew = true;
        this.rest.createCustomer().subscribe(customer => {
          this.customer = customer;
          this.customerDetailsHeaderComponent.setModel(this.customer, this.isNew, this.permissions.canAdd);
        });
      }

    });
  }

  ngAfterViewInit() {
    this.spinnerService.hide();
  }

  private setMenuButtonsPermissions() {
    this.menuButtons.find(b => b.text === 'COMMONBUTTONS_save').enabled = this.permissions.canEdit;
    this.saveButton.enabled = this.permissions.canEdit;
    this.menuButtons.find(b => b.text === 'Zablokuj kontrahenta').enabled = this.permissions.hasCustomerBlockingPermission && !this.customer.isBlocked;
    this.menuButtons.find(b => b.text === 'Odblokuj kontrahenta').enabled = this.permissions.hasCustomerBlockingPermission && this.customer.isBlocked;
  }


  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    if (tabChangeEvent.index === 2) {
      if (!this.canShowCustomerEmployees) {
        return;
      }
      if (this.customer.employees == undefined) {
        this.rest.getCustomerEmployees(this.customer.id).subscribe(employees => {
          this.customer.employees = employees;
          this.customerEmployeesComponent.setModel(this.customer);
        });
      } else {
        this.customerEmployeesComponent.setModel(this.customer);
      }
    }
    if (tabChangeEvent.index === 3) {
      if (!this.canShowSystemVersions) {
        return;
      }
      if (this.customer.systemVersions == undefined) {
        this.rest.getCustomerSystemVersions(this.customer.id).subscribe(systemVersions => {
          this.customer.systemVersions = systemVersions;
          this.customerSystemVersionsComponent.setModel(this.customer);
        });
      } else {
        this.customerSystemVersionsComponent.setModel(this.customer);
      }
    }
    if (tabChangeEvent.index === 4) {
      if (this.customer.licenses == undefined) {
        this.rest.getLicenses(this.customer.id).subscribe((licenses: License[]) => {
          this.customer.licenses = licenses;
          this.customerLicensesComponent.setModel(this.customer);
        })
      }
      else {
        this.customerLicensesComponent.setModel(this.customer);
      }
    }
  }

  public saveCustomer() {
    if (this.customerDetailsHeaderComponent.isInvalid()) {
      sweetAlert('Przed zapisem uzupełnij wymagane pola');
      return;
    }

    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    if (this.isNew == true || this.nipOld != this.customer.nip) {
      const actionExists = this.rest.existsCustomer;
      actionExists.call(this.rest, this.customer.nip).subscribe((result: boolean) => {
        if (result) {
          sweetAlert('Kontrahent o takim NIP już istnieje. Czy zapisać kartotekę kontrahenta?', {
            buttons: {
              yes: {
                text: 'Tak',
                value: 'yes'
              },
              no: {
                text: 'Nie',
                value: 'no',
              }
            }
          })
            .then((value) => {
              switch (value) {
                case 'yes':
                  this.saveCustomerAction();
                  break;
                case 'no':
                  this.isSaving = false;
              }
            });
        }
        else {
          this.saveCustomerAction();
        }
      });
    }
    else {
      this.saveCustomerAction();
    }


    // const action = this.rest.saveCustomer;
    // action.call(this.rest, this.customer, this.isNew).subscribe((result: Customer) => {
    //   if (this.isNew) {
    //     this.gridParamsRestoringService.saveAddingNewRowInfo(result.id);
    //   }
    //   this.isSaving = false;
    //   this.close();
    // });
  }

  private saveCustomerAction() {
    const action = this.rest.saveCustomer;
    action.call(this.rest, this.customer, this.isNew).subscribe((result: Customer) => {
      if (this.isNew) {
        this.gridParamsRestoringService.saveAddingNewRowInfo(result.id);
      }
      this.isSaving = false;
      this.close();
    });
  }

  private block() {
    if (this.customer.isBlocked) {
      sweetAlert(`Kontrahent ${this.customer.name} jest już zablokowany.`);
      return;
    }

    sweetAlert('Czy na pewno chcesz zablokować Kontrahenta?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    })
      .then((value) => {
        switch (value) {
          case 'yes':
            this.rest.blockCustomer(this.customer.id).subscribe((result: boolean) => {
              if (result) {
                this.close();
              }
            });
            break;
        }
      });
  }

  private unblock() {
    if (!this.customer.isBlocked) {
      sweetAlert(`Kontrahent ${this.customer.name} jest już odblokowany.`);
      return;
    }

    sweetAlert('Czy na pewno chcesz odblokować Kontrahenta?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    })
      .then((value) => {
        switch (value) {
          case 'yes':
            this.rest.unblockCustomer(this.customer.id).subscribe((result: boolean) => {
              if (result) {
                this.close();
              }
            });
            break;
        }
      });
  }

  private close() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}
